import { render, staticRenderFns } from "./CurrentGlyphEffects.vue?vue&type=template&id=13cc820f&scoped=true&"
import script from "./CurrentGlyphEffects.vue?vue&type=script&lang=js&"
export * from "./CurrentGlyphEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc820f",
  null
  
)

export default component.exports